import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

function SectionTeam() {
  return (
    <>
      <div className="cd-section" id="teams">

        <div className="section section-dark text-center landing-section">
          <Container>
            <h2 className="title">Let's talk about us</h2>
            <Row className="justify-content-md-center">
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/placeholder.jpg")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={(e) => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4"><b>Rabih G. Al-Maila</b></CardTitle>
                        <h6 className="card-category text-muted">
                          <b>
                            Managing Director
                          </b>
                        </h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                      <b>
                        Teamwork is so important that it is virtually impossible
                        for you to reach the heights of your capabilities or make
                        the money that you want without becoming very good at it.
                      </b>
                    </p>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      className="btn-link btn-just-icon mr-1"
                      color="twitter"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fa fa-twitter" />
                    </Button>
                    <Button
                      className="btn-link btn-just-icon mr-1"
                      color="dribbble"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fa fa-dribbble" />
                    </Button>
                    <Button
                      className="btn-link btn-just-icon"
                      color="linkedin"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fa fa-linkedin" />
                    </Button>
                  </CardFooter>
                  <Button
                    className="btn-round"
                    color="neutral"
                    type="button"
                    to="/OurTeam"
                    tag={Link}
                    outline
                  >
                    Check the rest of the team -{'>'}
                  </Button>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
    </>
  );
}

export default SectionTeam;
